import { useTranslation } from "react-i18next";
import { UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { getMissingQualificationGroups } from "../helpers";
import { smallText, tones } from "./constants";

const MissingQualifications = ({ shiftId, missing }) => {
    const { t } = useTranslation();
    const groups = getMissingQualificationGroups(missing);

    if (!groups.length) return null;

    return (
        <div className="d-flex flex-wrap" style={{ gap: 4 }}>
            {groups.map(({ field, values }) => {
                const id = `qualification-missing-${shiftId}-${field}`;
                return (
                    <span key={field}>
                        <span
                            id={id}
                            className="d-inline-flex align-items-center rounded px-2"
                            style={{ ...smallText, ...tones.warning, cursor: values.length ? "help" : "default" }}
                        >
                            <FontAwesomeIcon icon={faCircleExclamation} className="mr-1" />
                            {t(field)}
                            {values.length > 0 && <span className="font-weight-bold ml-1">{values.length}</span>}
                        </span>
                        {values.length > 0 && (
                            <UncontrolledTooltip target={id} placement="top">
                                {values.map((value) => <div key={value}>{value}</div>)}
                            </UncontrolledTooltip>
                        )}
                    </span>
                );
            })}
        </div>
    );
};

export default MissingQualifications;
